import React from "react";
import styled from "styled-components";
// import opensound from "../assets/opensound.png";
// import openvideo from "../assets/openvideo.png";
import { QRTCVideoStreamType } from "../qrtc_web_sdk/RoomParams";
import {isIOS} from "../qrtc_web_sdk/core/utils"

type QRTCVideoViewProps = {
  userIndex: number;
  userVideoDom: any;
  userAudioDom: any;
  switchStream: (userIndex: number, type: QRTCVideoStreamType) => void;
};

export default function QRTCVideoView(props: QRTCVideoViewProps) {
  const { userIndex, userVideoDom, userAudioDom, switchStream } = props;

  return (
    <React.Fragment>
      <div>
      {isIOS ?
          <Video ref={userVideoDom} autoPlay muted playsInline controls={false}></Video>
          :
          <Video ref={userVideoDom} autoPlay muted playsInline controls={false}></Video>
        }
        <Video ref={userVideoDom} autoPlay muted controls={false}></Video>
        <Button>视频</Button>
        <Button>音频</Button>
        <Button
          onClick={() => {
            switchStream(userIndex, QRTCVideoStreamType.QRTCVideoStreamTypeBig);
          }}
        >
          小流
        </Button>
      </div>
      <audio ref={userAudioDom} autoPlay muted={false} controls={false} />
    </React.Fragment>
  );
}

const Button = styled.button``;

const Video = styled.video`
  display: flex;
  width: 20vw;
  height: 20vh;
  background-color: #ffffff;
`;
